import { createElement } from 'react'
import { injectIntl } from 'react-intl'

const withIntl = Component => props => createElement(injectIntl(Component), props)

export default withIntl
